import React, { useContext, useState } from "react";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";
import { BsArrowUp, BsList } from "react-icons/bs"; // Importing hamburger icon (BsList)
import { ThemeContext } from "./ThemeContext";
import Project from "./Project";
import Projects from "./Projects";
import Skills from "./Skills";
import Blog from "./Blog";

const HomePage = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const [menuOpen, setMenuOpen] = useState(false); // State for managing menu visibility

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen); // Toggle menu state
  };

  return (
    <div className={`min-h-screen ${theme === "dark" ? "bg-gray-900 text-white" : "bg-[#edf2f8] text-black"} flex flex-col scroll-smooth`}>
      {/* Navbar */}
      <nav className="flex justify-between items-center px-8 py-4 shadow-md fixed top-0 w-full z-20 bg-opacity-90 backdrop-blur-lg">
        <div className="text-3xl font-bold">
          <span className={`${theme === "dark" ? "text-white" : "text-black"}`}>NIL</span>
          <span className="text-red-500">ESH.</span>
        </div>
        
        {/* Hamburger Icon for Mobile */}
        <div className="lg:hidden flex items-center">
          <button onClick={handleMenuToggle} className="text-2xl text-red-500 focus:outline-none">
            <BsList />
          </button>
        </div>

        {/* Menu Links */}
        <div
          className={`lg:flex lg:items-center lg:space-x-6 lg:text-lg ${
            menuOpen ? "absolute top-full left-0 w-full bg-white dark:bg-gray-900 shadow-lg p-4 flex flex-col space-y-4 text-center" : "hidden"
          }`}
        >
          <a href="#home" className="text-red-500 font-semibold">
            HOME
          </a>
          <a href="#about" className="hover:text-red-500">
            ABOUT
          </a>
          <a href="#work" className="hover:text-red-500">
            WORK
          </a>
          <a href="#skills" className="hover:text-red-500">
            SKILLS
          </a>
          <a href="#blogs" className="hover:text-red-500">
            BLOG
          </a>
          <a href="#contact" className="hover:text-red-500">
            CONTACT
          </a>
        </div>

        {/* Theme Toggle Button */}
        <div className="">
          <button
            onClick={toggleTheme}
            className="text-lg bg-gray-200 p-2 rounded-full hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600"
          >
            {theme === "dark" ? "☀️" : "🌙"}
          </button>
        </div>
      </nav>

      {/* Main Section */}
      <div id="home" className="max-h-[100vh] h-screen flex flex-col-reverse lg:flex-row items-center justify-center lg:gap-32 gap-4">
        <div>
          <div className="flex-1 space-y-6 lg:pr-8">
            <p className="text-lg lg:text-2xl font-medium">Hello, my name is</p>
            <h1 className="text-4xl lg:text-7xl font-bold">Nilesh Raut</h1>
            <p className="text-3xl lg:text-4xl font-medium">
              I'm a <span className="border-b-2 border-red-500 text-red-500">Full Stack Developer.</span>
            </p>
            <button className="mt-8 px-6 py-3 bg-red-500 text-white text-xl font-semibold rounded-lg shadow-lg hover:bg-red-600">
              Resume
            </button>
          </div>
        </div>
        <div>
          <img
            src={'/profile.jpg'}
            alt="Nilesh Raut"
            className="rounded-full h-64 w-64 object-cover"
          />
        </div>
      </div>

      {/* Projects Section */}
      <div id="about">
        <Project />
      </div>
      <div id="work">
        <Projects />
      </div>
      <div id="skills">
        <Skills />
      </div>
      <div id="blogs">
        <Blog />
      </div>

      {/* Social Icons */}
      <div className="fixed bottom-6 left-6 flex flex-col items-center space-y-4">
        <a
          href="https://www.linkedin.com/in/nilesh-raut-8584a81ab/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-red-500 p-3 rounded-full text-white hover:scale-110 transition-transform"
        >
          <FaLinkedin size={20} />
        </a>
        <a
          href="https://github.com/NileshRaut-code"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-red-500 p-3 rounded-full text-white hover:scale-110 transition-transform"
        >
          <FaGithub size={20} />
        </a>
        <a
          href="mailto:nileshrautv.sit.comp@gmail.com"
          className="bg-red-500 p-3 rounded-full text-white hover:scale-110 transition-transform"
        >
          <FaEnvelope size={20} />
        </a>
      </div>

      {/* Scroll to Top */}
      <div className="fixed bottom-6 right-6">
        <button
          className="bg-red-500 p-3 rounded-full text-white shadow-lg hover:bg-red-600 hover:scale-110 transition-transform"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <BsArrowUp size={20} />
        </button>
      </div>
    </div>
  );
};

export default HomePage;
